import { IDamageDetailEditForm } from 'reducers/page/damage-detail/damage-detail.props';

export const DAMAGE_DETAIL_EDIT_FORM = 'DAMAGE_DETAIL_EDIT_FORM';

export const setDamageDetailEditForm = (editForm: Partial<IDamageDetailEditForm>) => ({
  type: DAMAGE_DETAIL_EDIT_FORM,
  payload: editForm
});
